import { Year } from "./year";
import { Month } from "./month";
import { DatePicker } from "./date";
import { DateTime } from "./time";
import { Hours } from "./hours";
import { Minute } from "./minute";

// const p = new DateTime();
// p.setModel();
// p.change = function(e) {
//   console.log(e);
// };

export function $hfsDatePicker(sett, cn) {
  let picker = null;
  if (sett.elem) {
    sett.elem.blur();
  }
  switch (sett.format) {
    case "YYYY":
    case "year":
      picker = new Year(sett);
      break;
    case "YYYY-MM":
    case "YYYYMM":
    case "month":
      picker = new Month(sett);
      break;
    case "YYYY-MM-DD":
    case "YYYYMMDD":
    case "date":
      picker = new DatePicker(sett);
      break;
    case "YYYY-MM-DD HH":
    case "YYYYMMDDHH":
    case "hours":
      picker = new Hours(sett);
      break;
    case "YYYY-MM-DD HH:mm":
    case "YYYYMMDDHHmm":
    case "minute":
      picker = new Minute(sett);
      break;
    default:
      picker = new DateTime(sett);
  }
  picker.setModel(sett.model);
  picker.change = (o) => {
    cn(o);
    picker = null;
  };
}
